import { createSlice } from '@reduxjs/toolkit'
import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'

const initialState = {
  campaigns: [],
  campaignAdGroups: [],
  targetAdGroupKeywords: [],
  loading: false,
  error: false,
}

export const fetchCampaigns = createAxiosThunk(
  'dashboard/copyKeywords/fetchCampaigns',
  bizChannelId => api.ad.getBizChannelNotDeletedCampaigns(bizChannelId)
)

export const fetchCampaignAdGroups = createAxiosThunk(
  'dashboard/copyKeywords/fetchCampaignAdGroups',
  campaignId => api.ad.getCampaignNotDeletedAdGroups(campaignId)
)

export const fetchAdGroupKeywords = createAxiosThunk(
  'dashboard/copyKeywords/fetchAdGroupKeywords',
  adGroupId => api.ad.getNotDeletedKeywords(adGroupId)
)

export const copyKeywordsSlice = createSlice({
  name: 'dashboard/copyKeywords',
  initialState,

  reducers: {
    reset: () => initialState,
  },

  extraReducers: builder => {
    builder.addCase(fetchCampaigns.pending, state => {
      state.loading = true
    })

    builder.addCase(fetchCampaigns.fulfilled, (state, { payload }) => {
      state.campaigns = payload.campaigns
      state.loading = false
    })

    builder.addCase(fetchCampaigns.rejected, (state, { error, payload }) => {
      state.loading = false
      state.error = payload || error || true
    })

    builder.addCase(fetchCampaignAdGroups.pending, state => {
      state.loading = true
    })

    builder.addCase(fetchCampaignAdGroups.fulfilled, (state, { payload }) => {
      state.campaignAdGroups = payload.adGroupDtos
      state.loading = false
    })

    builder.addCase(
      fetchCampaignAdGroups.rejected,
      (state, { error, payload }) => {
        state.loading = false
        state.error = payload || error || true
      }
    )

    builder.addCase(fetchAdGroupKeywords.pending, state => {
      state.loading = true
    })

    builder.addCase(fetchAdGroupKeywords.fulfilled, (state, { payload }) => {
      state.loading = false
      state.targetAdGroupKeywords = payload.keywordDtos.map(({ id, text }) => ({
        id,
        text,
      }))
    })

    builder.addCase(
      fetchAdGroupKeywords.rejected,
      (state, { error, payload }) => {
        state.loading = false
        state.error = payload || error || true
      }
    )
  },
})

export const { reset } = copyKeywordsSlice.actions
export default copyKeywordsSlice.reducer
